import { erpAxios } from '.';

const setKrdOdborGrupa = async (data) => {
  const res = await erpAxios.post(`/odborGrupe/setKrdOdborGrupa`, data);
  return res;
};

export default setKrdOdborGrupa;
